import { ArrowRight, MapPin, X } from "lucide-react";
import { zoneName, subName } from "../lib/i18n";
import { organInfo, labelFor } from "../lib/organInfo";

export const ZoneHint = ({ t, lang, selection, onClose }) => (
  <div className="pointer-events-none absolute inset-x-0 bottom-6 z-10 flex justify-center px-4">
  <div className="card fade-up pointer-events-auto flex items-center gap-3 rounded-full py-2 pl-4 pr-2" data-testid="zone-hint" key={selection.key}>
    <MapPin size={16} className="text-orange-600" />
    <p className="text-sm text-slate-600">
      <span className="font-semibold text-slate-900" data-testid="selected-zone-name">{zoneName(lang, selection.zone, selection.side)}</span>
      <span className="hidden sm:inline"> · {t("pickDetail")}</span>
    </p>
    <button data-testid="zone-hint-close-btn" onClick={onClose} className="grid h-7 w-7 place-items-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700" aria-label={t("close")}><X size={15} /></button>
  </div>
  </div>
);

export const BackToBody = ({ t, onClick }) => (
  <button data-testid="back-to-body-btn" onClick={onClick} aria-label={t("close")} title={t("close")}
    className="card fade-up absolute bottom-3 right-[214px] z-20 grid h-11 w-11 place-items-center rounded-full text-slate-600 transition-transform hover:scale-110 hover:text-slate-900 sm:bottom-6 sm:right-[256px]">
    <X size={20} />
  </button>
);

const OrganCard = ({ lang, info }) => (
  <div className="mt-1.5 border-t border-slate-200/70 pt-1.5" data-testid="organ-info-card">
    <p className="text-[11px] leading-snug text-slate-600" data-testid="organ-info-function">{info.fn}</p>
    <p className="mt-1 text-[9px] font-semibold uppercase tracking-wider text-cyan-700">{labelFor(lang)}</p>
    <div className="mt-0.5 flex flex-wrap gap-1" data-testid="organ-info-disorders">
      {info.dis.map((d) => <span key={d} className="rounded-full bg-cyan-50 px-1.5 py-0.5 text-[10px] text-cyan-900 ring-1 ring-cyan-200">{d}</span>)}
    </div>
  </div>
);

export const ZonePanel = ({ t, lang, selection, subzone, onStart, onClose, loading }) => {
  const info = organInfo(lang, subzone);
  return (
    <div className="card fade-up absolute bottom-3 right-3 z-20 w-[190px] rounded-xl p-2.5 sm:bottom-6 sm:right-6 sm:w-[220px]" data-testid="zone-panel" key={subzone}>
      <div className="flex items-start justify-between gap-1">
        <div className="min-w-0">
          <p className="truncate text-[10px] text-slate-500">{zoneName(lang, selection.zone, selection.side)}</p>
          <p className="font-display truncate text-sm font-bold leading-tight text-slate-900" data-testid="selected-subzone-name">{subName(lang, subzone)}</p>
        </div>
        <button data-testid="zone-panel-close-btn" onClick={onClose} className="grid h-6 w-6 shrink-0 place-items-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700" aria-label={t("close")}><X size={13} /></button>
      </div>
      {info && <OrganCard lang={lang} info={info} />}
      <button data-testid="start-consultation-btn" disabled={loading} onClick={onStart} className="btn-primary mt-2 w-full !py-1.5 !text-xs">
        {t("startConsult")} <ArrowRight size={13} />
      </button>
    </div>
  );
};
